import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

import { push } from 'connected-react-router'
import { logout } from 'redux/modules/auth'
import { MaterialLoader } from 'components/loaders'
import { notification } from 'redux/modules/app'
import config from 'config'
import { getCustomHomePageCode } from '../../../utils/cookies'

@connect(null, { logout, push, notification })
class Logout extends Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    push: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { location } = this.props

    const storedCode = getCustomHomePageCode()

    const url = storedCode ? `${config.publicPath}/${storedCode}` : `${config.publicPath}/`

    this.props.logout().then(() => {
      this.props.push({
        pathname: url,
        state: { loggedOut: true }
      })

      if (get(location, 'state.inactivity')) {

        if(storedCode){
          this.props.push({
            state: { ...location.state },
            pathname: url
          })
        } else {
          this.props.push({
            state: { ...location.state },
            pathname: `${config.publicPath}/logout-inactive`
          })
        }

        return
      }

      !get(location, 'state.disableNotification', false) &&
        this.props.notification("You've been logged out", {
          status: 'success',
          intlKey: 'notifications.you_have_been_logged_out'
        })
    })
  }

  render() {
    return (
      <div
        style={{
          width: 300,
          margin: '10px auto',
          fontSize: '1.6em',
          textAlign: 'center'
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <FormattedMessage
            id="notifications.logging_out"
            defaultMessage="Logging out..."
          />
        </div>

        <MaterialLoader />
      </div>
    )
  }
}

export default Logout
